import { Link } from 'react-router-dom';
import { Icon, type IconName } from '@/components/Icon';
import { useTooltip } from '@/hooks/useTooltip';
import type { AttentionItem, AttentionKind } from '@/api/dashboard';

/** Иконка по причине — читается быстрее, чем один и тот же значок у всех строк. */
const KIND_ICON: Record<AttentionKind, IconName> = {
  expired: 'alertCircle',
  expiring: 'clock',
  // Та же иконка, что у раздела «Тесты» в меню — иначе колба ни с чем не связана.
  'no-tests': 'testChecklist',
};

/**
 * Строка списка. Высота фиксирована (по ней считается, где обрезать список на
 * трёх пунктах), поэтому причина не переносится, а обрезается — целиком её
 * показывает типовой тултип страницы.
 */
function Row({ item }: { item: AttentionItem }) {
  const company = item.company ?? 'Без названия';
  const tooltip = useTooltip<HTMLLIElement>(`${company}: ${item.issue}`);

  return (
    <li
      className={`attention-list__row attention-list__row--${item.severity}`}
      ref={tooltip.ref}
      {...tooltip.handlers}
    >
      <span className={`attention-list__icon attention-list__icon--${item.severity}`}>
        <Icon name={KIND_ICON[item.kind]} size={17} />
      </span>
      <div className="attention-list__body">
        <div className="attention-list__company">{company}</div>
        <div className="attention-list__issue">{item.issue}</div>
      </div>
      {/* Действие ведёт в карточку клиента сразу туда, где его выполняют:
          продление — правка «Общего», подключение тестов — вкладка «Тесты». */}
      <Link
        className="btn btn--secondary btn--sm"
        to={`/clients/${item.clientId}`}
        state={item.kind === 'no-tests' ? { openTab: 'tests' } : { autoEdit: true }}
      >
        {item.actionLabel}
      </Link>
      {tooltip.node}
    </li>
  );
}

export function AttentionList({ items }: { items: AttentionItem[] }) {
  if (items.length === 0) {
    return <p className="attention-list__empty">Всё под контролем — ничего не требует внимания.</p>;
  }

  return (
    <ul className="attention-list">
      {items.map((item) => (
        <Row key={item.clientId} item={item} />
      ))}
    </ul>
  );
}
